 /**
 * 操作权限处理
 */

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const pms = localStorage.getItem('pms')
    const userPermissions = pms?JSON.parse(pms) : []
    if (value && value instanceof Array && value.length > 0) {
      const hasPermissions = value.some(per => {
        return userPermissions.includes(per)
      })
      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  }
}
